export const REG_URL = '^(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})([/\\w .-]*)*/?(\\?[\\w\\d._%+-=&amp;]*)?$';

export const REGEX_TIN_VALID = /^[A-Za-z]{1,2}\d{9,14}$/;

export const REGEX_POSTCODE_MY = /^\d{5}$/;

// Indonesia NPWP (Nomor Pokok Wajib Pajak) regex (new & old regex)
// Matches a 16-digit NPWP (new format) or a 15-digit NPWP with formatting (old format)
export const REGEX_NPWP_ID = /^(\d{16}|\d{2}\.\d{3}\.\d{3}\.\d-\d{3}\.\d{3})$/;

export const REGEX_BANK_ACCOUNT_NUMBER = /^\d{10,16}$/;

export const REGEX_FULL_NAME = /^[A-Za-z\s''-]{3,100}$/;



// WEBPACK FOOTER //
// ./src/constants/regex.js